import { CheckCircle2 } from 'lucide-react';

import type { SiteContent } from '../../content/types';
import { Card, CardContent } from '../ui/card';
import { Container } from '../layout/container';
import { SectionHeading } from './section-heading';

interface IntroSectionProps {
  content: SiteContent;
}

export function IntroSection({ content }: IntroSectionProps): JSX.Element {
  return (
    <section className="py-12 sm:py-16">
      <Container className="grid gap-6 lg:grid-cols-[1.2fr_1fr] lg:items-start">
        <SectionHeading title={content.introSection.headline} description={content.introSection.text} />
        <Card className="bg-white">
          <CardContent className="space-y-3 p-6">
            {content.introSection.highlights.map((highlight) => (
              <div key={highlight} className="flex items-start gap-3">
                <CheckCircle2 className="mt-0.5 h-4 w-4 text-[color:var(--color-success)]" />
                <p className="text-sm text-[color:var(--color-text)]">{highlight}</p>
              </div>
            ))}
          </CardContent>
        </Card>
      </Container>
    </section>
  );
}
